// import { env, ENV } from 'mocktail';
// import {mockWrapper} from './util';
import DragDropContext from 'react-dnd/lib/DragDropContext';

let DragDropContextMock;

// if (env() === ENV.TESTING) {
// 	DragDropContextMock = (context) => {
// 		return mockWrapper;
// 	};
// }
// else {
	DragDropContextMock = DragDropContext;
// }

export default DragDropContextMock;
